import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ReferenceLine,
} from "recharts";
import { TrendingUp } from "lucide-react";
import { api } from "../lib/api";

const fmtGbp = (v) => `£${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export default function MarginTrend({ projectId, months = 12, title = "Net operating margin trend" }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    const qs = `months=${months}${projectId ? `&project_id=${projectId}` : ""}`;
    api.get(`/opex/margin-trend?${qs}`).then(({ data }) => { if (alive) setData(data); }).catch(() => {});
    return () => { alive = false; };
  }, [projectId, months]);

  if (!data) return null;
  const hasAny = data.series.some((s) => s.income_gbp || s.spend_gbp);
  if (!hasAny) return null;

  return (
    <section className="swiss-card p-5" data-testid="margin-trend">
      <div className="label flex items-center gap-2 mb-1"><TrendingUp size={12} /> {title}</div>
      <div style={{ width: "100%", height: 260 }}>
        <ResponsiveContainer>
          <ComposedChart data={data.series} margin={{ top: 10, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--line)" />
            <XAxis dataKey="month" tick={{ fontSize: 10 }} />
            <YAxis tick={{ fontSize: 10 }} width={64} tickFormatter={(v) => `£${(v / 1000).toFixed(0)}k`} />
            <Tooltip formatter={(v) => fmtGbp(v)} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <ReferenceLine y={0} stroke="var(--ink-2)" />
            <Bar dataKey="income_gbp" name="Income" fill="#15934F" barSize={14} radius={[2, 2, 0, 0]} />
            <Bar dataKey="spend_gbp" name="OPEX spend" fill="#C0392B" barSize={14} radius={[2, 2, 0, 0]} />
            <Line type="monotone" dataKey="net_margin_gbp" name="Net margin" stroke="#16A39B" strokeWidth={2.5} dot={{ r: 2 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
